import { ErrorOption } from "react-hook-form";
interface ErrorMessageProps {
  error: ErrorOption;
}
export function FormErrorMessage({ error: { message } }: ErrorMessageProps) {
  return message ? (
    <div className="text-active-red -mt-5 mb-5">{message}</div>
  ) : null;
}
interface BackendErrorMessageProps {
  error: any;
}
export function BackendErrorMessage({ error }: BackendErrorMessageProps) {
  return error && typeof error.message === "string" ? (
    <div className="text-active-red">{error.message}</div>
  ) : null;
}
